import { z } from 'zod';

import { LanguageEnum } from '../../enums';
import { languageEnumValidator, levelEnumValidator } from '../../validators';

const WordWithOccurrencesSchema = z.object({
  occurrences: z.number().positive().optional().default(1),
  text: z.string(),
});

export const GenerateStorySchema = z.object({
  languages: z
    .array(languageEnumValidator)
    .optional()
    .default([LanguageEnum.RU]),
  context: z.string().optional(),
  count: z.number().optional().default(3),
  level: levelEnumValidator,
  paragraphs: z.number().positive().optional().default(1),
  words: z.array(WordWithOccurrencesSchema).min(1),
});

export type IWordWithOccurrencesDto = z.infer<typeof WordWithOccurrencesSchema>;
export type IGenerateStoryDto = z.infer<typeof GenerateStorySchema>;
